<template>
  <div>
    <h2>
      <span class="step-name">
        Animal Numbers - Sheep
      </span>
      <comments field-name='heading_animal_numbers_sheep'></comments>
    </h2>
    <h3>Animal numbers are numbers wintered or expected to be wintered for the consult year</h3>

    <div class="step-section" v-for="gf_animal in enabledAnimals('sheep', false)" :key="'sheep_'+gf_animal.id">
      <h3> {{ gf_animal.name }} </h3>

      <div class="row">
        <div class="col-md-6 col-md-offset-3">
          <text-area label="Animal Notes from Ezyvet" :field-name="`animal_${gf_animal.id}-notes`" disabled>
          </text-area>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <h3>Previous Consult</h3>

          <div class="form-group input-box">
            <label>MA Ewes</label>
            <input type="text" class="form-control" :value="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-ma_ewes`]" disabled>
          </div>

          <div class="form-group input-box">
            <label>2 Tooths</label>
            <input type="text" class="form-control" :value="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-two_tooths`]" disabled>
          </div>

          <div class="form-group input-box">
            <label>Hoggets</label>
            <input type="text" class="form-control" :value="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-hoggets`]" disabled>
          </div>

          <div class="form-group input-box">
            <label>Rams</label>
            <input type="text" class="form-control" :value="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-rams`]" disabled>
          </div>

          <div class="form-group input-box">
            <label>Purchased Store Lambs</label>
            <input type="text" class="form-control" :value="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-purchased_store_rams`]" disabled>
          </div>

          <div class="form-group input-box">
            <label>Maternal Breed</label>
            <input type="text" class="form-control" :value="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-maternal_breed`]" disabled>
          </div>

          <div class="form-group input-box">
            <label>Terminal Breed</label>
            <input type="text" class="form-control" :value="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-paternal_breed`]" disabled>
          </div>

          <div class="form-group input-box">
            <div class="form-check">
            <input class="form-check-input" type="checkbox" :checked="getFieldValue('PREVIOUS_CONSULT_DATA')[`animal_${gf_animal.id}-is_stud_flock`]" disabled>
              <label class="form-check-label" for="stud_breeder">
                Stud Flock
              </label>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <h3>This Year</h3>

          <number-input label="MA Ewes"
                        :field-name="`animal_${gf_animal.id}-ma_ewes`">
          </number-input>

          <number-input label="2 Tooths"
                        :field-name="`animal_${gf_animal.id}-two_tooths`">
          </number-input>

          <number-input label="Hoggets"
                        :field-name="`animal_${gf_animal.id}-hoggets`">
          </number-input>

          <number-input label="Rams"
                        :field-name="`animal_${gf_animal.id}-rams`">
          </number-input>

          <number-input label="Purchased Store Lambs"
                        :field-name="`animal_${gf_animal.id}-purchased_store_rams`">
          </number-input>

          <text-input label="Maternal Breed"
                      :field-name="`animal_${gf_animal.id}-maternal_breed`">
          </text-input>

          <text-input label="Terminal Breed"
                      :field-name="`animal_${gf_animal.id}-paternal_breed`">
          </text-input>

          <check-box label="Stud Flock"
                     :field-name="`animal_${gf_animal.id}-is_stud_flock`">
          </check-box>
        </div>
      </div>
    </div>

    <div class="step-section" v-for="gf_animal in newAnimals('sheep')" :key="'new_sheep_'+gf_animal.frontend_id">

      <h3> {{ gf_animal.name }} - (Newly created) </h3>

      <div class="row">
        <div class="col-md-6">
          <h3>This Year</h3>

          <number-input label="MA Ewes"
                        :field-name="`new_animal_${gf_animal.frontend_id}-ma_ewes`">
          </number-input>

          <number-input label="2 Tooths"
                        :field-name="`new_animal_${gf_animal.frontend_id}-two_tooths`">
          </number-input>

          <number-input label="Hoggets"
                        :field-name="`new_animal_${gf_animal.frontend_id}-hoggets`">
          </number-input>

          <number-input label="Rams"
                        :field-name="`new_animal_${gf_animal.frontend_id}-rams`">
          </number-input>

          <number-input label="Purchased Store Lambs"
                        :field-name="`new_animal_${gf_animal.frontend_id}-purchased_store_rams`">
          </number-input>

          <text-input label="Maternal Breed"
                      :field-name="`new_animal_${gf_animal.frontend_id}-maternal_breed`">
          </text-input>

          <text-input label="Paternal Breed"
                      :field-name="`new_animal_${gf_animal.frontend_id}-paternal_breed`">
          </text-input>


          <check-box label="Stud Flock"
                     :field-name="`new_animal_${gf_animal.frontend_id}-is_stud_flock`">
          </check-box>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'
import { mapGetters } from 'vuex'

export default {
  name: 'AnimalNumbersSheep',
  mixins: [ baseComponent ],
  computed:
  {
    ...mapGetters('currentConsult', ['enabledAnimals', 'newAnimals']),
  }
};
</script>

